app.controller('coachCtrl', function ($uibModal, $http) {
    const self = this;

    const ModalType = {
        IMAGE: 'image',
        PERSONAL_DETAILS: 'personal-details',
        PRESENTATION: 'presentation',
        SOCIAL: 'social',
        PROGRAM: 'program',
        LIVE_WORKOUT: 'live-workout',
    };

    const getComponentName = (type) => {
        let component;

        switch (type) {
            case ModalType.IMAGE:
                component = 'coachImageForm';
                break;
            case ModalType.PERSONAL_DETAILS:
                component = 'coachPersonalForm';
                break;
            case ModalType.PRESENTATION:
                component = 'coachPresentationForm';
                break;
            case ModalType.SOCIAL:
                component = 'coachSocialForm';
                break;
            case ModalType.PROGRAM:
                component = 'coachProgramForm';
                break;
            case ModalType.LIVE_WORKOUT:
                component = 'coachLiveWorkoutForm';
                break;
        }
        return component;
    };

    const getSelectors = (type) => {
        let selectors;
        switch (type) {
            case ModalType.IMAGE:
                selectors = [{
                    selector: '.coach-profile  div.avatar > img', value: coachProfile.user.picture
                }];
                break;
            case ModalType.PERSONAL_DETAILS:
                selectors = [];
                break;
            case ModalType.PRESENTATION:
                selectors = [];
                break;
            case ModalType.SOCIAL:
                selectors = [];
                break;
            case ModalType.PROGRAM:
                selectors = [];
                break;
            case ModalType.LIVE_WORKOUT:
                selectors = [];
                break;
        }
    };

    const renderError = (err) => {
        console.error('Unexpected Error: ', err);
    };

    const updateUsage = (type) => {
        return (coach) => {
            const selectors = getSelectors(type, coach);
            selectors.forEach((item) => {
                $(item.selector).html(item.value);
            });
        };
    };

    self.edit = (type, id) => {
        $uibModal
            .open({
                component: getComponentName(type),
                animation: false,
                resolve: {
                    coach: function () {
                        return $http.get(`/coach/json/${id}`)
                            .then((response) => {
                                return response.data;
                            });
                    }
                }
            })
            .result
            .then(() => {
                window.location.reload();
            }, () => {

            })
            .catch(renderError);
    };

    self.toggleVisible = () => {
        if(this.stripeConnectAccountId){
            $http.get(`/coach/toggle-visible/${this.id}`);
        } else {
            this.form.visible = false;
            alert('Please link stripe account first.');
        }
    };

    self.toggleAvailable = () => {
        $http.get(`/coach/toggle-available/${this.id}`);
    };

    self.inviteCoach = (coach) => {
        $uibModal
            .open({
                component: 'coach-invite',
                windowClass: 'coach-invite-modal',
                animation: false,
                size: 'lg',
                resolve: {
                    coach: function () {
                        return coach;
                    }
                }
            })
            .result
            .then(() => {
                this.invited = true;
            }, () => {

            })
            .catch(renderError);
    };

    self.needPremium = (feature) => {
        $uibModal
            .open({
                component: 'need-premium',
                windowClass: 'need-premium-modal',
                animation: false,
                size: 'md',
                resolve: {
                    feature: function () {
                        return feature;
                    }
                }
            })
            .result
            .then(() => {

            }, () => {

            })
            .catch(renderError);
    };

    self.shareLink = (link) => {
        $uibModal
            .open({
                component: 'share-link',
                windowClass: 'share-link-modal',
                animation: false,
                size: 'lg',
                resolve: {
                    link: function () {
                        return link;
                    }
                }
            })
            .result
            .then(() => {

            }, () => {

            })
            .catch(renderError);
    };

});
